import React from 'react';
import './style.scss';

const Footer: React.FC = () => {
    return (
        <div className="app-footer">
            <div className="app-footer-content">
                <span className="app-footer-links">
                    <a href="http://gb.corp.163.com/gb/about/overview.html" target="_blank" rel="noopener noreferrer">公司简介</a>
                    <span className="footer-link-line">|</span>
                    <a href="https://help.mail.163.com/" target="_blank" rel="noopener noreferrer">邮箱帮助中心</a>
                    <span className="footer-link-line">|</span>
                    <a href="https://pw.mail.163.com/terms.html" target="_blank" rel="noopener noreferrer">服务条款</a>
                    <span className="footer-link-line">|</span>
                    <a href="https://help.mail.163.com/service.html" target="_blank" rel="noopener noreferrer">客户服务</a>
                    <span className="footer-link-line">|</span>
                    <a href="https://mail.163.com/html/agreement/doc.html" target="_blank" rel="noopener noreferrer">隐私政策</a>
                </span>
                <span className="app-footer-years">网易公司版权所有 © 1997-{(new Date()).getFullYear()}</span>
            </div>
        </div>
    )
}

export default Footer;
